<template>
  <main id="main-content">
    <script
      v-if="jsonLd"
      type="application/ld+json"
      v-html="jsonLd"
    />
    <ProductDetailPageCentra
      v-if="product"
      :product="product"
      :status-message="productStatusMessage || globalStatusMessage"
      @setSwatch="setSwatch"
    >
      <component
        :is="block.component"
        v-for="block in storyblokDataToUse.right_column_content"
        :key="block.id"
        v-bind="block"
        v-editable="block"
        :product="product"
        :right-column="true"
      />
    </ProductDetailPageCentra>
    <component
      :is="block.component"
      v-for="block in storyblokDataToUse.main_content"
      :key="block.id"
      v-bind="block"
      v-editable="block"
      :page-name="storyblokDataToUse.breadcrumbName || product.name"
      :product="product"
      :main-content="true"
    />
  </main>
</template>
<script>
import Product from '@made-people/centra-storyblok-nuxt-shared/lib/views/Product'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductView',
  mixins: [Product],
  props: {
    // The storyblok content to render below the pdp details, passed when in
    // visual editor mode, otherwise we use the data bundled from backend
    page: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      swatchProductId: null,
    }
  },
  computed: {
    ...mapGetters({
      getProductById: 'centra-product/getPdpProductById',
    }),
    // TODO make this reactive
    storyblokDataToUse() {
      return this.page?.content ?? this.product?.storyblokData ?? []
    },
    globalStatusMessage() {
      return this.$store.getters['storyblok/settings']?.pdpStatusMessage?.html || ''
    },
    productStatusMessage() {
      return this.storyblokDataToUse.statusMessage?.html || null
    },
  },
  methods: {
    fetchProduct() {
      if (this.product) {
        return
      }
      return this.$store.dispatch('centra-product/lookupProduct', this.getProductId()).then(this.setInitialSizes).then(this.getPostLoadCentraProductPromises)
    },
    async setSwatch({ productId, swatchUrl }) {
      // this.$router.replace(this.$u(swatchUrl))
      await this.$store.dispatch('centra-product/lookupProduct', productId)
      this.swatchProductId = productId
      history.replaceState({}, null, swatchUrl)
    },
    getProductId() {
      return this.swatchProductId ?? this.id
    },
  },
}
</script>
